import React, { useEffect, useState } from 'react';
import { useGetDta } from '../../hooks/useGetDta';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import LoadinSpin from '../ui/LoadinSpin';
import { Button, Card, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';
import PageTitle from '../PageTitle';
import { useForm } from '../../hooks/useForm';
const ZapSing = () => {
    const [keey, setKeey] = useState('');
    const { loading, data } = useGetDta('main/general/zapsing');
    const { setResp } = useContextInfo();
    const [load, setLoad] = useState(false);
    const [enable, setEnable] = useState(false);
    const [sandbox, setSandbox] = useState(false);
    const [validated, setValidated] = useState(false);
    const [values, handleInputChange, setFormValue] = useForm({
        id: '',
        token: '',
        plantilla: '',
    });
    useEffect(() => {
        if (data.id) {
            const datos = JSON.parse(data.items);
            console.log('********:', datos);
            setEnable(datos.enable);
            setSandbox(datos.sandbox);
            setFormValue({ ...values, ...datos, id: data.id });
        }
    }, [data]);

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(
                `plus/general`,
                { info: 'zapsing', id: data.id, items: { ...values, enable, sandbox }, keeyb: keey },
                'PUT'
            );
            setResp(res);
        }
        setLoad(false);
    };
    if (loading) return <LoadinSpin />;
    return (
        <div>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Ajustes', path: '/ajustes' },
                    { label: 'Contaratos digitales', path: '/admin/digitaldoc', active: true },
                ]}
                title={'Contaratos digitales'}
            />
            <Card>
                <Card.Header as="h3" className="text-center">
                    CONFIGURACIÓN CONTRATOS DIGITALES ZAPSING
                </Card.Header>
                <Card.Body>
                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                        <Row>
                            <Col sm="2">
                                {' '}
                                <Form.Group className="mb-3" controlId="validationCustom17">
                                    <InputGroup>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            label="Modo sandbox"
                                            checked={sandbox}
                                            onChange={() => setSandbox(!sandbox)}
                                        />
                                    </InputGroup>
                                </Form.Group>{' '}
                                <Form.Group className="mb-3" controlId="validationCustom18">
                                    <InputGroup>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            label="Activar"
                                            checked={enable}
                                            onChange={() => setEnable(!enable)}
                                        />
                                    </InputGroup>
                                </Form.Group>{' '}
                            </Col>

                            <Col>
                                {' '}
                                <Form.Group className="mb-3" controlId="validationCusto">
                                    <Form.Label>TOKEN DE ACCESO</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={values.token}
                                        required
                                        name="token"
                                        placeholder="API-KEEY-ZAPSING"
                                        onChange={handleInputChange}
                                    />
                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                </Form.Group>{' '}
                            </Col>

                            <Col>
                                {' '}
                                <Form.Group className="mb-3" controlId="validationCusto">
                                    <Form.Label>ID PLANTILLA</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={values.plantilla}
                                        required
                                        name="plantilla"
                                        placeholder="12312-312312-3123"
                                        onChange={handleInputChange}
                                    />
                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                </Form.Group>{' '}
                            </Col>
                        </Row>

                        {load ? (
                            <Button color="primary" disabled>
                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                Guardando...
                            </Button>
                        ) : (
                            <Button type="submit">Guardar</Button>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ZapSing;
